import client from '@/store/api/client'

export default {
  getTimelogs(start_date, end_date) {
    return client.pget(`/api/data/timelog/${start_date}/${end_date}`)
  },

  addTimelog(person_id, task_id, start_time, end_time, day) {
    return client.pget(`/actions/timelog/${person_id}/${task_id}/${start_time}/${end_time}/${day}`)
  }
}
